import React, { useEffect, useState } from 'react'
import LatinoTemplateDefault from 'src/components/template/la/'
import { laDiscountPriceMonthly } from 'src/constants/planData/latinoPlanData'
import { laChannelCount } from 'src/constants/planData/latinoPlanData'
import { getURIParamValue } from 'src/modules/utils/analytics'

export default (props) => {
  const [hasCode, setHasCode] = useState(false)
  const offerCode = getURIParamValue(props.location.search, 'offer')

  useEffect(() => {
    if (offerCode) {
      setHasCode(true)
    }
  }, [offerCode])

  return (
    <LatinoTemplateDefault
      location={props.location}
      lang="es"
      market="latino"
      ctaText="Acceder Ahora"
      offerBanner={{
        title: [
          '¡Oferta Especial Exclusiva de SEIS!',
          'Disfruta de $10 de descuento al mes en los próximos 3 meses.',
        ],
      }}
      //REMOVED: univision_removed video and annotations
      // video={videos.latino.videoUrl}
      // annotations={videos.latino.annotations}
      //REPLACED: univision_removed poster images
      poster="https://assets-imgx.fubo.tv/marketing/lp/images/posters/LaLiga_Ver1_Web.jpg"
      posterMobile="https://assets-imgx.fubo.tv/marketing/lp/images/posters/LaLiga_Ver1_Mobile.jpg"
      title={
        <>
          Ahorra en TV en vivo para toda <span className="no-wrap">la familia</span>
        </>
      }
      subtitle={
        !hasCode && (
          <>
            Accede ahora por solo <span className="green-underline">${laDiscountPriceMonthly}</span>{' '}
            el primer mes
          </>
        )
      }
      tagline={
        <>
          Más de ${laChannelCount} canales con deportes, noticias,
          <span className="desktop-line-break">novelas y entretenimiento en español.</span>
        </>
      }
      networkSet="entertainmentLatino"
      noteLink="/la/learn/"
      offerCode={offerCode}
      disableLAPlanCards={true}
    />
  )
}
